// apps/web/src/pages/Support.tsx
import { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import { api } from '../lib/api';

// ── Distributor lookup ────────────────────────────────────────────────────────

type Distributor = {
  name: string;
  description: string;
  email?: string;
  phone?: string;
  website?: string;
  contactPerson?: string;
};

const DISTRIBUTORS: Record<string, Distributor> = {
  'United States': { name: 'MontiPower USA & Canada', description: 'Oil & gas, infrastructure and industrial maintenance.', email: 'info@montipower.com', phone: '+1 703 396 8777', contactPerson: 'Chuck Lockard' },
  'Canada':        { name: 'MontiPower USA & Canada', description: 'Oil & gas, infrastructure and industrial maintenance.', email: 'info@montipower.com', phone: '+1 703 396 8777', contactPerson: 'Chuck Lockard' },
  'Brazil':        { name: 'MontiPower Brasil', description: 'Large-scale industrial, offshore & energy applications.', email: 'sebastian.pohlmann@montipower.com', website: 'https://montipowerbrasil.com.br', contactPerson: 'Sebastian Pohlmann' },
  'Mexico':        { name: 'MontiPower México', description: 'Industrial & energy sectors with local technical assistance.', email: 'enrique.sanchez@montipower.com', contactPerson: 'Enrique Sanchez' },
  'Argentina':     { name: 'MontiPower Argentina', description: 'Industrial maintenance & infrastructure projects.' },
  'Bolivia':       { name: 'MontiPower Bolivia / Peru', description: 'Mining & infrastructure: portable surface preparation.' },
  'Peru':          { name: 'MontiPower Bolivia / Peru', description: 'Mining & infrastructure: portable surface preparation.' },
  'Chile':         { name: 'MontiPower Chile', description: 'Mining & industrial maintenance: durable, efficient solutions.' },
  'Denmark':       { name: 'Mouritsen', description: 'Industrial maintenance & coating applications.', email: 'SPE@mouritsen.com', contactPerson: 'Simon Pedersen' },
  'France':        { name: '3X Engineering', description: 'Infrastructure & industrial sectors.', email: 'lv@3xeng.com' },
  'Germany':       { name: 'MontiPower Germany', description: 'Industrial maintenance & coating applications.', email: 'Zoran.kovarcek@montipower.com', contactPerson: 'Zoran Kovarcek' },
  'Italy':         { name: 'Montenovo Italia', description: 'Manufacturing & infrastructure sectors.', email: 'm.roberto@montenovoitalia.it', contactPerson: 'Roberto Montenovo' },
  'Netherlands':   { name: 'MontiPower Netherlands', description: 'Home base: direct access to innovation, engineering and technical expertise.', email: 'herman.devries@montipower.com', contactPerson: 'Herman de Vries' },
  'Belgium':       { name: 'MontiPower Belgium', description: 'Industrial maintenance & coating applications.', email: 'jc.buyssens@montipower.com', contactPerson: 'Jean Claude Buyssens' },
  'Norway':        { name: 'Presserv AS', description: 'Offshore & maritime sectors: corrosion-focused solutions.', email: 'thomas.merenyi@presserv.com', contactPerson: 'Thomas Merenyi' },
  'Poland':        { name: 'MontiPower Poland', description: 'Industrial maintenance & coating applications.' },
  'Spain':         { name: 'Caditec', description: 'Industrial & infrastructure projects.', email: 'andres@caditec.es', contactPerson: 'Andrés Gonzalez Marchena' },
  'Turkey':        { name: 'MontiPower Turkey', description: 'Industrial & infrastructure applications.' },
  'United Kingdom':{ name: 'Cactus Industrial', description: 'Automotive, rail & industrial sectors.', email: 'jgallagher@cactusindustrial.com', website: 'https://cactusindustrial.com', contactPerson: 'Jamie Gallagher' },
  'Ireland':       { name: 'Cactus Industrial', description: 'Automotive, rail & industrial sectors.', email: 'jgallagher@cactusindustrial.com', website: 'https://cactusindustrial.com', contactPerson: 'Jamie Gallagher' },
  'Hungary':       { name: 'MontiPower Hungary', description: 'Industrial maintenance & coating applications.', email: 'balazs.gerencser@montipower.com', contactPerson: 'Balazs Gerencser' },
  'Australia':     { name: 'MontiPower Australia', description: 'Mining, marine & heavy industry.', email: 'phil.chester@montipower.com', website: 'https://montipower.com.au', contactPerson: 'Phil Chester' },
  'China':         { name: 'MontiPower China', description: 'Local availability, technical support and access to MontiPower technologies.', email: 'info@shfreeland.com', website: 'https://montipowerchina.com' },
  'Indonesia':     { name: 'MontiPower Indonesia', description: 'Marine, offshore & industrial sectors.' },
  'Japan':         { name: 'MontiPower Japan', description: 'Precision-focused solutions for industrial & technical surface preparation.', email: 'takashi.kaetsu@montipower.com', website: 'https://montipowerjapan.com', contactPerson: 'Takashi Kaetsu' },
  'South Korea':   { name: 'MontiPower Korea', description: 'Shipbuilding & heavy industry: high-performance tools.', email: 'vector.dky@montipower.com', contactPerson: 'DK Yoon' },
  'Philippines':   { name: 'SEPCO Philippines', description: 'Marine & infrastructure sectors.', email: 'francisedwardendayasepco@gmail.com', contactPerson: 'Francis Edward Endaya' },
  'Singapore':     { name: 'MontiPower Singapore', description: 'Strategic Southeast Asia hub: marine, offshore & industrial.' },
  'Thailand':      { name: 'Arkco Thailand', description: 'Industrial maintenance & coating applications.', email: 'kevin@arkcothailand.com', contactPerson: 'Kevin' },
  'Vietnam':       { name: 'MontiPower Vietnam', description: 'Marine, infrastructure & industrial sectors.' },
  'Malaysia':      { name: 'MontiPower South East Asia', description: 'Regional network with local expertise and fast distribution.', website: 'https://montipower.com.my' },
  'South Africa':  { name: 'BAMR', description: 'Mining, infrastructure & industrial sectors.', email: 'sales@bamr.co.za', contactPerson: 'Graham Duk' },
  'Ghana':         { name: 'i-Neema', description: 'Industrial maintenance & coating applications.', email: 'michaelagu@i-neema.com', contactPerson: 'Michael Agu' },
  'Israel':        { name: 'MontiPower Israel', description: 'Precision surface preparation for industrial & high-tech applications.' },
  'United Arab Emirates': { name: 'MontiPower Middle East', description: 'Oil & gas and infrastructure: safe, efficient, ATEX-compliant solutions.', email: 'mohamed.hashique@montipower.com', contactPerson: 'Mohamed Hashique' },
  'Saudi Arabia':  { name: 'MontiPower Middle East', description: 'Oil & gas and infrastructure: safe, efficient, ATEX-compliant solutions.', email: 'mohamed.hashique@montipower.com', contactPerson: 'Mohamed Hashique' },
  'Angola':        { name: 'Monti PWA', description: 'Industrial maintenance & coating applications.', email: 'a.blecha@montipower.com', contactPerson: 'A. Blecha' },
};

const DEFAULT_DISTRIBUTOR: Distributor = {
  name: 'MontiPower International',
  description: 'Contact MontiPower directly and we\'ll route you to the right partner.',
  email: 'info@montipower.com',
  phone: '+49 2242 9090 630',
  website: 'https://montipower.com/pages/distributors',
};

// ── Page data ─────────────────────────────────────────────────────────────────

const CONSUMABLES = [
  { title: 'Drive Belts', description: 'Replacement drive belts for all Montipower models.', url: 'https://montipower.com/pages/spare-parts', badge: 'Consumable' },
  { title: 'Spare Parts', description: 'Genuine Montipower spare parts and replacement components.', url: 'https://montipower.com/pages/spare-parts', badge: 'Parts' },
  { title: 'Accessories', description: 'Guards, adaptors, and other accessories for your Montipower tools.', url: 'https://montipower.com/collections/accessories', badge: 'Accessory' },
];

const HELP_LINKS = [
  { title: 'Product Manuals & Downloads', description: 'Instruction manuals, safety sheets, and technical documentation.', url: 'https://montipower.com/pages/manuals', icon: BookIcon },
  { title: 'How-To Guides & Videos', description: 'Step-by-step guides and video tutorials for surface preparation.', url: 'https://montipower.com/pages/guides', icon: PlayIcon },
  { title: 'FAQ', description: 'Answers to common questions about tools, shipping, and warranty.', url: 'https://montipower.com/pages/faq', icon: QuestionIcon },
  { title: 'Contact Support', description: 'Reach our technical support team for tool troubleshooting or service enquiries.', url: 'https://montipower.com/pages/contact', icon: ChatIcon },
  { title: 'Training', description: 'On-site and remote training from Montipower specialists to get the best out of your tools.', url: 'https://montipower.com/pages/training', icon: GraduationIcon },
];

const WARRANTY_INFO = [
  { q: 'How long is the warranty?', a: 'All Montipower tools come with a 2-year manufacturer warranty from the date of purchase.' },
  { q: 'What is covered?', a: 'Manufacturing defects in materials and workmanship. Normal wear items such as belts, brushes, and pads are consumables and not covered.' },
  { q: 'How do I make a claim?', a: 'Register your tool first, then go to Warranty Claims in the sidebar to submit a claim. Attach proof of purchase and photos of the defect.' },
  { q: 'Where can I buy replacement consumables?', a: 'Directly from the Montipower webshop using the links above. We recommend using genuine Montipower consumables to maintain tool performance.' },
];

// ── Component ─────────────────────────────────────────────────────────────────

export default function Support() {
  const [country, setCountry] = useState<string | null>(null);

  useEffect(() => {
    api.get<{ country?: string }>('/account/me').then(d => {
      setCountry(d.country ?? null);
    }).catch(() => setCountry(null));
  }, []);

  const distributor = country ? (DISTRIBUTORS[country] ?? DEFAULT_DISTRIBUTOR) : null;

  return (
    <Layout>
    <div className="max-w-3xl mx-auto">
      <h1 className="text-2xl font-bold mb-1" style={{ color: '#0b0d0e' }}>Support & Help</h1>
      <p className="text-sm mb-8" style={{ color: '#8f9b9b' }}>Consumables, manuals, and everything you need to keep your Montipower tools running.</p>

      {/* ── Local distributor ────────────────────────────────── */}
      {distributor && (
        <section className="mb-8">
          <h2 className="text-base font-semibold mb-3" style={{ color: '#0b0d0e' }}>Your Local Contact</h2>
          <div className="card" style={{ borderLeft: '4px solid #e00000' }}>
            <div className="flex items-start justify-between gap-4">
              <div>
                <div className="flex items-center gap-2 mb-1">
                  <span className="font-semibold text-sm" style={{ color: '#0b0d0e' }}>{distributor.name}</span>
                  {country && <span className="badge badge-steel">{country}</span>}
                </div>
                <p className="text-xs mb-3" style={{ color: '#8f9b9b' }}>{distributor.description}</p>
                <div className="flex flex-wrap gap-3">
                  {distributor.contactPerson && (
                    <span className="text-xs font-medium" style={{ color: '#374151' }}>Contact: {distributor.contactPerson}</span>
                  )}
                  {distributor.email && (
                    <a href={`mailto:${distributor.email}`} className="text-xs font-medium" style={{ color: '#e00000' }}>
                      {distributor.email}
                    </a>
                  )}
                  {distributor.phone && (
                    <a href={`tel:${distributor.phone}`} className="text-xs font-medium" style={{ color: '#374151' }}>
                      {distributor.phone}
                    </a>
                  )}
                  {distributor.website && (
                    <a href={distributor.website} target="_blank" rel="noopener noreferrer" className="text-xs font-medium" style={{ color: '#e00000' }}>
                      Website →
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
          {!DISTRIBUTORS[country ?? ''] && (
            <p className="text-xs mt-2" style={{ color: '#8f9b9b' }}>
              No specific distributor listed for {country}.{' '}
              <a href="https://montipower.com/pages/distributors" target="_blank" rel="noopener noreferrer" style={{ color: '#e00000' }}>
                See the full directory →
              </a>
            </p>
          )}
        </section>
      )}

      {country === null && (
        <div className="card mb-8" style={{ borderLeft: '4px solid #d9d9d9' }}>
          <p className="text-sm" style={{ color: '#374151' }}>
            Set your country in{' '}
            <a href="/account" style={{ color: '#e00000' }}>Account Settings</a>
            {' '}to see your local Montipower distributor contact here.
          </p>
        </div>
      )}

      {/* ── Reorder consumables ──────────────────────────────── */}
      <section className="mb-8">
        <h2 className="text-base font-semibold mb-3" style={{ color: '#0b0d0e' }}>Reorder Consumables</h2>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {CONSUMABLES.map(item => (
            <a
              key={item.title}
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
              className="card hover:shadow-md transition-shadow flex flex-col gap-2 no-underline"
            >
              <div className="flex items-center justify-between">
                <span className="font-semibold text-sm" style={{ color: '#0b0d0e' }}>{item.title}</span>
                <span className="badge badge-steel">{item.badge}</span>
              </div>
              <p className="text-xs flex-1" style={{ color: '#8f9b9b' }}>{item.description}</p>
              <span className="text-xs font-semibold flex items-center gap-1" style={{ color: '#e00000' }}>
                Shop now <ArrowIcon />
              </span>
            </a>
          ))}
        </div>
      </section>

      {/* ── Help & documentation ─────────────────────────────── */}
      <section className="mb-8">
        <h2 className="text-base font-semibold mb-3" style={{ color: '#0b0d0e' }}>Help & Documentation</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {HELP_LINKS.map(item => {
            const Icon = item.icon;
            return (
              <a
                key={item.title}
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                className="card hover:shadow-md transition-shadow flex items-start gap-4 no-underline"
              >
                <div className="w-9 h-9 rounded flex items-center justify-center flex-shrink-0" style={{ background: '#fff0f0' }}>
                  <Icon className="w-5 h-5" style={{ color: '#e00000' }} />
                </div>
                <div>
                  <p className="font-semibold text-sm" style={{ color: '#0b0d0e' }}>{item.title}</p>
                  <p className="text-xs mt-0.5" style={{ color: '#8f9b9b' }}>{item.description}</p>
                </div>
              </a>
            );
          })}
        </div>
      </section>

      {/* ── Warranty FAQ ─────────────────────────────────────── */}
      <section>
        <h2 className="text-base font-semibold mb-3" style={{ color: '#0b0d0e' }}>Warranty FAQ</h2>
        <div className="card divide-y" style={{ '--tw-divide-opacity': 1 } as React.CSSProperties}>
          {WARRANTY_INFO.map((item, i) => (
            <div key={i} className="py-4 first:pt-0 last:pb-0">
              <p className="font-semibold text-sm mb-1" style={{ color: '#0b0d0e' }}>{item.q}</p>
              <p className="text-sm" style={{ color: '#374151' }}>{item.a}</p>
            </div>
          ))}
        </div>
        <p className="text-xs mt-4" style={{ color: '#8f9b9b' }}>
          More questions?{' '}
          <a href="https://montipower.com/pages/contact" target="_blank" rel="noopener noreferrer" style={{ color: '#e00000' }}>
            Contact Montipower support →
          </a>
        </p>
      </section>
    </div>
    </Layout>
  );
}

// ── Icons ─────────────────────────────────────────────────────────────────────

function ArrowIcon() {
  return <svg width="12" height="12" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}><path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" /></svg>;
}
function BookIcon({ className, style }: { className?: string; style?: React.CSSProperties }) {
  return <svg className={className} style={style} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.75}><path strokeLinecap="round" strokeLinejoin="round" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" /></svg>;
}
function PlayIcon({ className, style }: { className?: string; style?: React.CSSProperties }) {
  return <svg className={className} style={style} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.75}><circle cx="12" cy="12" r="9" /><path strokeLinecap="round" strokeLinejoin="round" d="M10 8l6 4-6 4V8z" /></svg>;
}
function QuestionIcon({ className, style }: { className?: string; style?: React.CSSProperties }) {
  return <svg className={className} style={style} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.75}><circle cx="12" cy="12" r="9" /><path strokeLinecap="round" strokeLinejoin="round" d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3M12 17h.01" /></svg>;
}
function ChatIcon({ className, style }: { className?: string; style?: React.CSSProperties }) {
  return <svg className={className} style={style} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.75}><path strokeLinecap="round" strokeLinejoin="round" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" /></svg>;
}
function GraduationIcon({ className, style }: { className?: string; style?: React.CSSProperties }) {
  return <svg className={className} style={style} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.75}><path strokeLinecap="round" strokeLinejoin="round" d="M12 14l9-5-9-5-9 5 9 5z"/><path strokeLinecap="round" strokeLinejoin="round" d="M12 14l6.16-3.422A12.083 12.083 0 0112 21a12.083 12.083 0 01-6.16-10.422L12 14z"/><path strokeLinecap="round" strokeLinejoin="round" d="M20 9v6"/></svg>;
}
